import PubSub from "underpub-js";
import gsap from 'gsap';

var ListingArticles = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingArticles',
	};

	$.extend(true, this.options, options);

};

ListingArticles.prototype.init = function() {

	var self = this;

	self.$filterCollapseButton = self.options.$el.find(`.${self.options.baseClass}__navigation-collapse`);
	self.$filtersContainer = self.options.$el.find(`.${self.options.baseClass}__navigation`);

	self.initFilterCollapseAnimation();

	self.$filterCollapseButton.on('click', function() {
		if (self.filterCollapseAnimationTL.reversed()) {
			self.filterCollapseAnimationTL.play();
		} else {
			self.filterCollapseAnimationTL.reverse();
		}
	});

	PubSub.subscribe('Sitewide:resized', function() {
		self.filterCollapseAnimationTL.invalidate(); // forces GSAP to recalculate widths/heights, so if browser width changes animation will still work properly
	});

};

ListingArticles.prototype.initFilterCollapseAnimation = function() {

	const self = this;

	const $filtersContainer = self.$filtersContainer;
	const $indicatorLine = self.$filterCollapseButton.find(`.${self.options.baseClass}__navigation-collapse__indicator__line--animated`);

	self.filterCollapseAnimationTL = gsap.timeline({
		paused: true,
		reversed: true,
		defaults: {
			duration: 0.5,
			ease: "power1.out"
		}
	})
	.fromTo($indicatorLine,
		{
			rotation: '-90deg'
		},
		{
			duration: 0.25,
			ease: "none",
			rotation: 0
		}
	)
	.fromTo($filtersContainer,
		{
			width: 0
		},
		{
			width: "auto"
		},
		"<"
	)
	.fromTo($filtersContainer,
		{
			borderBottomWidth: 0
		},
		{
			duration: 0.02,
			borderBottomWidth: 2
		}
	)
	.fromTo($filtersContainer,
		{
			height: 0
		},
		{
			height: "auto",
		},
		"<"
	)

};

export default ListingArticles;
